module.exports = __webpack_public_path__ + "img/i_exc_gr.fd1ebbfe.svg";